<template>
	<div class="print-solicitacao" style="overflow-x: hidden">
		<div class="row print">
			<flCabecalho widthimg="130" top="16" />
		</div>
		<div class="table-responsive" style="margin-top: 8px">
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="5" style="background: #eee" class="text-center">
							{{ _traducao('global', 'fichaCadastralFuncional').toUpperCase() }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colspan="3">
							<small>{{ _traducao('global', 'nomeCompleto') }}</small>
							<p>{{ form.nome | na }}</p>
						</td>
						<td>
							<span>
								<small>{{
									_traducao('menuAGnovoUsuario', 'menuAGnomeGuerra')
								}}</small>
								<p>{{ form.nome_guerra | na }}</p>
							</span>
						</td>
						<td>
							<span>
								<small>{{ _traducao('global', 'trigrama') }}</small>
								<p>{{ form.trigrama | na }}</p>
							</span>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'sexo') }}</small>
							<p>{{ form.sexo | na }}</p>
						</td>
						<td>
							<span>
								<small>{{ _traducao('global', 'dataNascimento') }}</small>
								<p>{{ form.data_nascimento | na }}</p>
							</span>
						</td>
						<td>
							<span>
								<small>{{ _traducao('global', 'estadoCivil') }}</small>
								<p>{{ form.estado_civil | na }}</p>
							</span>
						</td>
						<td>
							<small>{{ _traducao('global', 'escolaridade') }}</small>
							<p>{{ form.escolaridade | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'localDeNascimento') }}</small>
							<p>{{ form.naturalidade | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'nacionalidade') }}</small>
							<p>{{ form.nacionalidade | na }}</p>
						</td>
						<td colspan="4">
							<small>{{ _traducao('global', 'endereco') }}</small>
							<p>{{ form.endereco | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'bairro') }}</small>
							<p>{{ form.bairro | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'cep') }}</small>
							<p>{{ form.cep | cep }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'cidade') }}</small>
							<p>{{ form.cidade | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>RG</small>
							<p>{{ form.rg | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}</small>
							<p>{{ form.cpf | cpf }}</p>
						</td>
						<td>
							<small>CTPS</small>
							<p>{{ form.ctps | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('global', 'funcaoNaEmpresa') }}</small>
							<p>{{ cargo | na }}</p>
						</td>
					</tr>
					<tr>
						<td>
							<small>{{ _traducao('global', 'funcaoComoTripulante') }}</small>
							<p>{{ cargo | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'tipoDeLicenca') }}</small>
							<p>{{ licenca.sigla | na }}</p>
						</td>
						<td>
							<small>{{ _traducao('global', 'numeroLicenca') }}</small>
							<p>{{ funcao.numero_licenca | na }}</p>
						</td>
						<td colspan="2">
							<small>{{ _traducao('menuAGnovoUsuario', 'menuAGanac') }}</small>
							<p>{{ form.codigo_anac | na }}</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="table-responsive">
			<table class="table table-bordered table-condensed">
				<thead>
					<tr>
						<th colspan="4" style="background: #eee" class="text-center">
							{{ _traducao('global', 'vencimentos').toUpperCase() }}
						</th>
					</tr>
					<tr v-if="form.vencimentos && form.vencimentos.length > 0">
						<th style="background: #eee">
							{{ _traducao('global', 'tipo').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-center">
							{{ _traducao('global', 'emissao').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-center">
							{{ _traducao('global', 'validade').toUpperCase() }}
						</th>
						<th style="background: #eee" class="text-right">
							{{ _traducao('global', 'diasRestantes').toUpperCase() }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in form.vencimentos" :key="index">
						<td>{{ item.tipo | na }}</td>
						<td class="text-center">{{ item.emissao | data }}</td>
						<td class="text-center">{{ item.validade | data }}</td>
						<td class="text-right">{{ item.dias_restantes | na }}</td>
					</tr>
					<tr v-if="form.vencimentos && form.vencimentos.length <= 0">
						<td colspan="4" class="text-center">
							{{ _traducao('global', 'usuarioSemLicenca') }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<flGeradoPor />
	</div>
</template>
<script>
export default {
	props: ['cargos'],
	data() {
		return {
			form: {},
			licencas: []
		}
	},
	computed: {
		cargo() {
			const cargo = this.cargos.find((val) => val.id == this.form.cargo)
			return !cargo ? '' : cargo.descricao
		},
		funcao() {
			if (Array.isArray(this.form.funcao) && this.form.funcao.length > 0) {
				return this.form.funcao[0]
			}
			return {}
		},
		licenca() {
			const licenca = this.licencas.find((val) => val.id == this.funcao.id)
			return !licenca ? {} : licenca
		}
	},
	created() {
		this.carregarLicencas()
	},
	methods: {
		carregaForm(form) {
			this.form = form
		},
		carregarLicencas() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios(`/Licenca/get`, 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.licencas = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})
		}
	}
}
</script>